import Translation from './Translation';

export enum LanguagesEnum {
	ar = 'ar',
	bg = 'bg',
	cz = 'cz',
	de = 'de',
	en = 'en',
	es = 'es',
	fr = 'fr',
	hu = 'hu',
	it = 'it',
	pl = 'pl',
	ru = 'ru',
	sk = 'sk',
	tl = 'tl',
	tr = 'tr',
	uk = 'uk',
	zh = 'zh',
}

/**
 * @NOTE by adding new locale here, make sure to add it in next.config.js for routing
 * */

export const DEFAULT_LANGUAGE = LanguagesEnum.en;

export type Language = {
	code: string;
	name: string;
};

export type PlaceLanguagesType = {
	current: LanguagesEnum;
	content?: Translation | null;
};

export const LANGUAGES = Object.keys({ ...LanguagesEnum });
